import { SimpleResponse } from "./generic-response.model";

export interface Membership {
    incrementalID: number;
    resNetID: string;
    clpUserID: number;
    clpCompanyID: number;
    contactID: number;
    contractID?: number;
    membershipAccountName: string;
    membershipID?: number;
    primaryCaptainFirstName: string;
    primaryCaptainLastName: string;
    subscriptionType: string;
    membershipStartDate?: string;
    membershipCompany?: number;
    siteID?: number;
    clubID?: number;
    accountStatus: string;
    salesClosedDate: string;
    currentARDate: string;
    daysAR?: number;
    prePaidMonthlyAmount?: number;
    prePaidMonthlyPaymentThroughDate?: string;
    memberForMonths?: number;
    stripeCustomerID: string;
    resNetStatus: number;
    totalAccountReservations?: number;
    last12MonthsReservations?: number;
    securityDepositAmountHeld?: number;
    securityDepositedDate: string;
    securityDepositRefundRequestDate: string;
    neverStartedReason?: number;
    neverStartedNotes: string;
    neverStartedDate: string;
    cancellationReason?: number;
    cancellationRequestDate: string;
    cancellationDateLastDayOfMembership: string;
    daysMemberPriorToCancellation?: number;
    cancellationNotes: string;
    cancelledDaysRemainingInContract?: number;
    cancelledAmountRemaining?: number;
    purchasedVesselBrand?: number;
    purchasedFromBoatSimple?: boolean;
    terminationDate: string;
    terminationReason?: number;
    sentToCollectionsDate: string;
    collectionsVendor?: number;
    collectionsReceivedDate: string;
    collectionsReceivedAmount?: number;
    tradeReason?: number;
    dtOnboarded: string;
    dtCreated: string;
}

export interface MembershipItem {
    membershipIID: number;
    contractID: number;
    resNetID: string;
    clpUserID: number;
    clpCompanyID: number;
    contactID: number;

    membershipID: number;
    membershipAccountName: string;
    primaryCaptainFirstName: string;
    primaryCaptainLastName: string;
    primaryCaptainName: string;
    membershipCompany: string;
    subscriptionType?: number;

    membershipStartDate?: string;
    salesClosedDate?: string;
    currentARDate?: string;
    accountStatus: number;
    memberForMonths?: number;
    totalAccountReservations?: number;
    last12MonthsReservations?: number;
    dtOnboarded?: string;
    dtCreated?: string;
}

export interface MemContact {
    contactID: number;
    cmMemberID: number;
    clpCompanyID: number;
    clpUserID: number;
    membershipIID: number;
    contractID: number;
    membershipID: number;
    subscriptionID: number;
    membershipAccountName: string;
    genderID: number;
    csStatusID: number;
    captainTypeID: number;
    birthdate: string;
    socialSecurityNumber: string;
    associationToPrimaryCaptainID: number;
    onboardedByCLPUserID: number;
    bookingSystemMembershipID: string;
    bookingSystemUserID: number;
    driversLicenseNumber: string;
    emergencyContactName: string;
    emergencyContactPhoneNumber: string;
    relationshipToEmergencyContactID: number;
    emergencyContactMailingStreet: string;
    emergencyContactMailingStateID: number;
    emergencyContactMailingCity: string;
    emergencyContactMailingZip: string;
    emergencyMailingCountryID: number;
    lastBookingPortalActivity: string;
    csatAverageScore: number;
    dateOfLastReservation: string;
    googleAnalyticsCampaign: string;
    googleAnalyticsContent: string;
    googleAnalyticsMedium: string;
    googleAnalyticsSource: string;
    googleAnalyticsTerm: string;
    boatingExperienceID: number;
    photoURL: string;
    suspendedCaptain: boolean;
    contactName: string;
    uLastName: string;
    uFirstName: string;
    strGender: string;
    strCSStatus: string;
    strCaptainType: string;
    strAssociationToPrimaryCaptain: string;
    strRelationshipToEmergencyContact: string;
    strEmergencyContactMailingState: string;
    strEmergencyMailingCountry: string;
    strBoatingExperience: string;
    strOnboardedByCLPUser: string;
    strBookingSystemUser: string;
    strBookingSystemMembership: string;
}

export interface MemContactItem {
    contactID: number;
    cmMemberID: number;
    cmContractID: number;
    firstName: string;
    lastName: string;
    mobile: string;
    email: string;
    memberStatus: string;
    membershipIID: number;
    membershipID: number;
    subscriptionID: number;
    onboardedByCLPUserID: number;
    onboardedByCLPUser: string;
    dateOfLastReservation: string;
    photoURL: string;
    membershipAccountName: string;
}

export interface MemPolicyViolation {
    policyViolationID: number;
    contactID: number;
    clpCompanyID: number;
    clpUserID: number;
    contractID?: number;
    membershipIID: number;
    captainID?: number;
    feeTypeID?: number;
    feeDate?: string;
    feeNotes: string;
    lateArrivalTime?: string;
    fleetID?: number;
    reservationID?: number;
    createdByID?: number;
    feeAmount?: number;
    totalFeePaidByMember?: number;
    totalFeeDueByMember?: number;
    noPolicyViolationFound?: boolean;
    ownerID?: number;
    warningIssued?: boolean;
    policyViolation: string;
    contactName: string;
}

export interface MemPolicyViolationItem {
    policyViolationID: number;
    policyViolation: string;
    contactID: number;
    clpCompanyID: number;
    clpUserID: number;
    contractID?: number;
    membershipIID: number;
    captainID?: number;
    feeType: string;
    feeDate?: string; // Use string for ISO dates in JSON
    feeAmount?: number;
}

export interface MemPause {
    pauseID: number;
    contactID: number;
    clpCompanyID: number;
    clpUserID: number;
    membershipIID: number;
    pauseTypeID?: number;
    pauseStartDate?: string;
    pauseEndDate?: string;
    pauseAmount?: number;
    hardshipReasonID?: number;
    indefiniteReasonID?: number;
    contactName: string;
}

export interface MemPauseItem {
    pauseID: number;
    pause: string;
    contactID: number;
    clpCompanyID: number;
    clpUserID: number;
    membershipIID: number;
    pauseType: string;
    pauseStartDate?: string; // ISO string if serialized from JSON
    pauseEndDate?: string;   // ISO string if serialized from JSON
    pauseAmount?: number;
    contactName?: string;
}

export interface MemInsuranceDeductible {
    insuranceDeductibleID: number;
    contactID: number;
    clpCompanyID: number;
    clpUserID: number;
    membershipIID: number;
    protectionPlanID?: number;
    protectionStartDate?: string;
    protectionDeductibleAmount?: number;
    lostEquipmentCreditTotal?: number;
    protectionEndDate?: string;
    protectionStatusID?: number;
    contactName: string;
}

export interface MemInsuranceDeductibleItem {
    insuranceDeductibleID: number;
    insuranceDeductible: string;
    contactID: number;
    clpCompanyID: number;
    clpUserID: number;
    membershipIID: number;
    protectionPlan: string;
    protectionStatus: string;
    protectionDeductibleAmount?: number;
    lostEquipmentCreditTotal?: number;
    protectionStartDate?: string; // Use string for JSON dates, or Date if parsed
    protectionEndDate?: string;
}

export interface MemCase {
    caseID: number;
    contactID: number;
    clpCompanyID: number;
    clpUserID: number;
    membershipIID: number;
    caseNumber: string;
    statusID?: number;
    concernLevelID?: number;
    subject: string;
    failedInspectionLevel: number;
    description: string;
    reservationID?: number;
    caseResolution: string;
    vesselPlusLocation: string;
    vesselNo: string;
    caseOwnerId: number;
    transactionID?: number;
    formID?: number;
    transactionAmount?: number;
    invoiceLink: string;
    protectionPlan?: number;
    incidentDate?: string;
    daysToCaseClose?: number;
    caseOpenAge?: number;
    inspectionFormID?: number;
    workOrderID?: number;
    dockhand: string;
    deductibleApplied?: boolean;
    incidentDateTime?: string;
    incidentAmountTotal?: number;
    incidentType: string;
    incidentDescription: string;
    afterTaxAmount?: number;
    retailCostOfDamage?: number;
    jetRideDamageSavings?: number;
    caseOrigin?: number;
    caseReason?: number;
    memberConcernLevel?: number;
    internalComments: string;
    caseReasonDescription: string;
    userStory: string;
    dtOpened?: string;
    dtClosed?: string;
    webEmail: string;
    webCompany: string;
    webName: string;
    webPhone: string;
    filteringAttribute: string;
    createdBy?: number;
    dtCreated?: string;
    modifiedBy?: number;
    dtModified?: string;
}

export interface MemCaseItem {
    caseID: number;
    caseNumber: string;
    subject: string;
    dtOpened?: string;       // Use string for DateTime when serialized from JSON
    dtClosed?: string;       // Use string for DateTime when serialized from JSON
    caseReason: string;
    caseResolution: string;
    caseStatus: string;
    caseOwnerId: number;
    caseOwner: string;
    contactName: string;
    contactID: number;
}

export interface MemSubscription {
    subscriptionID: number;
    membershipIID: number;
    cmMemberID: number;
    contactID: number;
    contractID: number;
    paymentType: number;
    vCustomerID?: string;
    vPaymentMethodID?: string;
    baseAmount?: number;
    taxAmount?: number;
    surchargeAmount?: number;
    totalAmount?: number;
    paused?: boolean;
    status?: number;
    coupon?: string;
    billingDay?: number;
    dtNextBill?: string;
    errorMessage?: string;
    createdByID?: number;
    dtCreated?: string;
    modifiedByID?: number;
    dtModified?: string;
    contactName: string;
    subscription: string;
    vSubscriptionID: string;
}

export interface MemSubscriptionItem {
    subscriptionID: number;
    subscriptionName: string;
    paused: boolean;
    subscriptionStatus: string;
    paymentType: string;
    baseAmount: number;
    billingDay: number;
    dtNextBill: string;    // Use string for DateTime in JSON
}

export interface MemContactListRequest {
    clpCompanyId: number;
    timeFrame: number;
    sites: number[];
    users: number[];
    status: number;
    clubId: number;
    membershipIID: number;
    dateType: number;
    strdtStart: string;
    strdtEnd: string;
    dtStart: string;
    dtEnd: string;
}


export interface MembershipResponse extends SimpleResponse {
    memberships: MembershipItem[];
}

export interface MemContactResponse extends SimpleResponse {
    contacts: MemContactItem[];
}

export interface MemPolicyViolationResponse extends SimpleResponse {
    violations: MemPolicyViolationItem[];
}

export interface MemPauseResponse extends SimpleResponse {
    pauses: MemPause[];
}

export interface MemInsuranceDeductibleResponse extends SimpleResponse {
    deductibles: MemInsuranceDeductible[];
}

export interface MemSubscriptionResponse extends SimpleResponse {
    subscriptions: MemSubscription[];
}

export interface MemCaseResponse extends SimpleResponse {
    cases: MemCaseItem[];
}

export interface MembershipListRequest {
    clubId: number;
    timeFrame: number;
    sites: number[];
    users: number[];
    membershipAccountStatus: number;
    dateType: number;
    strdtStart: string;
    strdtEnd: string;
    dtStart: Date;
    dtEnd: Date;
}

export interface MemPolicyViolationListRequest {
    clubId: number;
    timeFrame: number;
    sites: number[];
    users: number[];
    feeTypeID: number;
    dateType: number;
    strdtStart: string;
    strdtEnd: string;
    dtStart: string;
    dtEnd: string;
}

export interface MemPauseListRequest {
    clubId: number;
    timeFrame: number;
    sites: number[];
    users: number[];
    pauseTypeID: number;
    dateType: number;
    strdtStart: string;
    strdtEnd: string;
    dtStart: string;
    dtEnd: string;
}

export interface MemInsuranceDeductibleListRequest {
    clubId: number;
    timeFrame: number;
    sites: number[];
    users: number[];
    protectionPlanID: number;
    protectionStatusID: number;
    dateType: number;
    strdtStart: string;
    strdtEnd: string;
    dtStart: string; // Use string for DateTime when receiving from JSON, or Date if always parsed
    dtEnd: string;
}

export interface MemCaseListRequest {
    clubId: number;
    contactId: number;
    timeFrame: number;
    sites: number[];
    users: number[];
    caseStatus: number;
    caseOrigin: number;
    caseReason: number;
    memberConcernLevel: number;
    dateType: number;      // byte in C# maps to number in TypeScript
    strdtStart: string;
    strdtEnd: string;
    dtStart: string;       // Use string for DateTime from JSON, or Date if always parsed
    dtEnd: string;
}

export interface MemSubscriptionListRequest {
    clubId: number;
    timeFrame: number;
    sites: number[];
    users: number[];
    subscriptionStatus: number;
    dateType: number;
    strdtStart: string;
    strdtEnd: string;
    dtStart: string; // Use string for DateTime if coming from JSON, or Date if always parsed
    dtEnd: string;
}

export interface REFMem_GetAllResponse extends SimpleResponse {
    ref_MemAccountStatus_List: REF_MemAccountStatus[];
    ref_MemAssociationToPrimaryCaptain_List: REF_MemAssociationToPrimaryCaptain[];
    ref_MemBillingMethod_List: REF_MemBillingMethod[];
    ref_MemBoatingExperience_List: REF_MemBoatingExperience[];
    ref_MemCancellationReason_List: REF_MemCancellationReason[];
    ref_MemCaptainType_List: REF_MemCaptainType[];
    ref_MemCaseConcernLevel_List: REF_MemCaseConcernLevel[];
    ref_MemCaseOrigin_List: REF_MemCaseOrigin[];
    ref_MemCaseReason_List: REF_MemCaseReason[];
    ref_MemCaseStatus_List: REF_MemCaseStatus[];
    ref_MemCollectionsVendor_List: REF_MemCollectionsVendor[];
    ref_MemCompany_List: REF_MemCompany[];
    ref_MemCSStatus_List: REF_MemCSStatus[];
    ref_MemFailedInspectionLevel_List: REF_MemFailedInspectionLevel[];
    ref_MemFeeType_List: REF_MemFeeType[];
    ref_MemGender_List: REF_MemGender[];
    ref_MemHardshipReason_List: REF_MemHardshipReason[];
    ref_MemIndefiniteReason_List: REF_MemIndefiniteReason[];
    ref_MemLocation_List: REF_MemLocation[];
    ref_MemNeverStartedReason_List: REF_MemNeverStartedReason[];
    ref_MemPauseType_List: REF_MemPauseType[];
    ref_MemProtectionPlan_List: REF_MemProtectionPlan[];
    ref_MemProtectionStatus_List: REF_MemProtectionStatus[];
    ref_MemPurchasedVesselBrand_List: REF_MemPurchasedVesselBrand[];
    ref_MemRegion_List: REF_MemRegion[];
    ref_MemRelationshipToEmergencyContact_List: REF_MemRelationshipToEmergencyContact[];
    ref_MemResNetStatus_List: REF_MemResNetStatus[];
    ref_MemSubscriptionType_List: REF_MemSubscriptionType[];
    ref_MemTerminationReason_List: REF_MemTerminationReason[];
    ref_MemTradeReason_List: REF_MemTradeReason[];
    ref_SubscriptionStatus_List: REF_SubscriptionStatus[];
}

export interface REF_MemCaseReason {
    reasonID: number;
    reason: string;
    active: boolean;
}

export interface REF_MemCaseStatus {
    statusID: number;
    status: string;
    active: boolean;
}

export interface REF_MemCollectionsVendor {
    vendorID: number;
    vendor: string;
    active: boolean;
}

export interface REF_MemCompany {
    companyID: number;
    company: string;
    active: boolean;
}

export interface REF_MemCSStatus {
    statusID: number;
    status: string;
    active: boolean;
}

export interface REF_MemFailedInspectionLevel {
    levelID: number;
    level: string;
    active: boolean;
}

export interface REF_MemFeeType {
    statusID: number;
    status: string;
    active: boolean;
}

export interface REF_MemGender {
    statusID: number;
    status: string;
    active: boolean;
}

export interface REF_MemHardshipReason {
    statusID: number;
    status: string;
    active: boolean;
}

export interface REF_MemIndefiniteReason {
    statusID: number;
    status: string;
    active: boolean;
}

export interface REF_MemLocation {
    locationID: number;
    regionID: number;
    location: string;
    active: boolean;
}

export interface REF_MemNeverStartedReason {
    reasonID: number;
    reason: string;
    active: boolean;
}

export interface REF_MemPauseType {
    statusID: number;
    status: string;
    active: boolean;
}

export interface REF_MemProtectionPlan {
    statusID: number;
    status: string;
    active: boolean;
}

export interface REF_MemProtectionStatus {
    statusID: number;
    status: string;
    active: boolean;
}

export interface REF_MemPurchasedVesselBrand {
    brandID: number;
    brand: string;
    active: boolean;
}

export interface REF_MemRegion {
    regionID: number;
    region: string;
    active: boolean;
}

export interface REF_MemRelationshipToEmergencyContact {
    statusID: number;
    status: string;
    active: boolean;
}

export interface REF_MemResNetStatus {
    statusID: number;
    status: string;
    active: boolean;
}

export interface REF_MemSubscriptionType {
    subTypeID: number;
    subType: string;
    active: boolean;
}

export interface REF_MemTerminationReason {
    reasonID: number;
    reason: string;
    active: boolean;
}

export interface REF_MemTradeReason {
    reasonID: number;
    reason: string;
    active: boolean;
}

export interface REF_SubscriptionStatus {
    statusID: number;
    status: string;
    active: boolean;
}

export interface REF_MemAccountStatus {
    statusID: number;
    status: string;
    active: boolean;
}

export interface REF_MemAssociationToPrimaryCaptain {
    statusID: number;
    status: string;
    active: boolean;
}

export interface REF_MemBillingMethod {
    methodID: number;
    method: string;
    active: boolean;
}

export interface REF_MemBoatingExperience {
    statusID: number;
    status: string;
    active: boolean;
}

export interface REF_MemCancellationReason {
    reasonID: number;
    reason: string;
    active: boolean;
}

export interface REF_MemCaptainType {
    statusID: number;
    status: string;
    active: boolean;
}

export interface REF_MemCaseConcernLevel {
    levelID: number;
    level: string;
    active: boolean;
}

export interface REF_MemCaseOrigin {
    originID: number;
    origin: string;
    active: boolean;
}



export interface MemContactListDropDown {
    id: number;
    id2: number;
    text: string;
}
